const fullScreens = document.querySelectorAll<HTMLElement>(
	'.block-full-screen:not(.is-style-disable-parallax)'
);

const maybeChangeParallax = () => {
	fullScreens.forEach((fullScreen) => {
		let headerHeight =
			getComputedStyle(document.documentElement).getPropertyValue('--headerHeightFull') ||
			'0';
		headerHeight = headerHeight.replace('px', '');

		const viewHeight = window.innerHeight - parseInt(headerHeight);

		if (viewHeight < fullScreen.offsetHeight) {
			fullScreen.classList.add('block-full-screen--disable-parallax');
		} else {
			fullScreen.classList.remove('block-full-screen--disable-parallax');
		}
	});
};

maybeChangeParallax();
window.addEventListener('load', maybeChangeParallax, { passive: true });
window.addEventListener('resize', maybeChangeParallax, { passive: true });
